var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"share-layer-box"},[_c('van-overlay',{staticClass:"share-box",attrs:{"z-index":"9999","show":_vm.shareShow},on:{"click":_vm.closeFun}},[_c('div',{staticClass:"wrapper"},[_c('img',{staticClass:"share-img",attrs:{"src":_vm.imageView('https://images.snsports.cn/FmvQf6AVN9k4UjIa2Y-JjdvoUjbk')}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }